import clsx from 'clsx';
import Image from 'next/image';
import React from 'react';

export const StepsSection = ({
  title,
  imgSrc,
  imgAlt,
  stepOneTitle,
  stepOneSection,
  stepTwoTitle,
  stepTwoSection,
  stepThreeTitle,
  stepThreeSection,
}) => {
  return (
    <section
      id="workProcess"
      className="w-full max-w-screen-lg mx-auto mt-[60px] pb-[60px]"
    >
      <h2 className="m-0 text-center text-[16px] font-light text-wtf-persianRed pb-[12px]">
        {title}
      </h2>
      <div className="flex flex-col justify-center items-center lg:flex-row">
        <div
          className={clsx(
            'flex-[1] basis-1/3',
            'max-w-[828px]',
            'hidden lg:!flex lg:!flex-row lg:!justify-center lg:!items-center',
          )}
        >
          <img
            src={imgSrc}
            alt={imgAlt}
            width={428}
            height={628}
            className="rounded-[12px]"
          />
        </div>
        <div className="shadow-darkRed h-full max-w-260 md:max-w-80 md:h-100 relative overflow-hidden rounded-[16px] !my-2 md:!mb-0 lg:hidden">
          <img
            width={300}
            height={728}
            src={imgSrc}
            alt={imgAlt}
            className={clsx(
              'lg:hidden',
              'h-full max-w-[576px]',
              'rounded-[12px]',
            )}
          />
        </div>
        <ul
          className={clsx(
            'list-none !px-0',
            'flex flex-col gap-[12px] md:w-1/2',
            'list-none',
          )}
        >
          <li>
            <div className="flex flex-col text-center lg:text-start">
              <div className="w-full text-xs">
                <p className="text-xs !m-0">Step 1</p>
                <h3 className="text-2xl font-bold mb-[20px] mt-0 p-0 ">
                  {stepOneTitle}
                </h3>
                {stepOneSection}
              </div>
            </div>
          </li>
          <li>
            <article className="flex flex-col text-center lg:text-start">
              <div className="w-full text-xs">
                <p className="text-xs !m-0">Step 2</p>
                <h3 className="text-2xl font-bold mb-[20px] mt-0 p-0">
                  {stepTwoTitle}
                </h3>
                {stepTwoSection}
              </div>
            </article>
          </li>
          <li>
            <article className="flex flex-col text-center lg:text-start">
              <div className="w-full text-xs">
                <p className="text-xs !m-0">Step 3</p>
                <h3 className="text-2xl font-bold mb-[20px] mt-0 p-0">
                  {stepThreeTitle}
                </h3>
                {stepThreeSection}
              </div>
            </article>
          </li>
        </ul>
      </div>
    </section>
  );
};
